import { render, staticRenderFns } from "./CorporateSSOLogin.vue?vue&type=template&id=2d4e57e2&scoped=true"
import script from "./CorporateSSOLogin.vue?vue&type=script&lang=js"
export * from "./CorporateSSOLogin.vue?vue&type=script&lang=js"
import style0 from "./CorporateSSOLogin.vue?vue&type=style&index=0&id=2d4e57e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e57e2",
  null
  
)

export default component.exports